import Offcanvas from 'bootstrap/js/dist/offcanvas';
const inlineSVG = require('inline-svg');
import { createPopper } from '@popperjs/core/lib/popper-lite.js';
import offset from '@popperjs/core/lib/modifiers/offset.js';

const body = document.querySelector('body');

let activePanel = null;
let activeHotspot = null;
let activeLogoBlock = null;
let activeTooltip = null;
let activePopper = null;
let isTransitioning = false;
let slideshowTimer = undefined;
let slideshowRunning = false;

function initMap() {
  const mapSvg = document.querySelector('.site-map svg');
  const hotspots = mapSvg.querySelectorAll('.panel-hotspot');
  const offcanvasElementList = document.querySelectorAll('.offcanvas');

  hotspots.forEach(hotspot => {
    hotspot.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (slideshowRunning) {
        skipSlideshow();
      }
    })
  })

  offcanvasElementList.forEach(panelElem => {
    const panelId = panelElem.getAttribute('id');
    const hotspot = mapSvg.querySelector(`[*|href="#${panelId}"]`);
    const logoBlock = document.getElementById('logo-block-' + hotspot.getAttribute('data-block'));
    const panel = new Offcanvas(panelElem);
    hotspot.classList.remove('disabled');

    hotspot.addEventListener('click', () => {

      if (isTransitioning === false) {

        if (activePanel && (activePanel !== panel)) {
          activePanel.hide();
        }

        if (activePanel === panel) {
          panel.hide();
        } else {
          panel.show();
          activeHotspot = hotspot;
          activePanel = panel;
          activeLogoBlock = logoBlock;
          activeHotspot.classList.add('active');
          activeLogoBlock.classList.add('active');
        }

      }
    })
  })

  const disabledHotspots = mapSvg.querySelectorAll('.panel-hotspot.disabled');

  function showTooltip(tooltip, popperInstance) {
    // Make the tooltip visible
    tooltip.classList.add('show');
    activeTooltip = tooltip;
    activePopper = popperInstance;

    // Enable the event listeners
    popperInstance.setOptions((options) => ({
      ...options,
      modifiers: [
        ...options.modifiers,
        { name: 'eventListeners', enabled: true },
      ],
    }));

    // Update its position
    popperInstance.update();
  }

  function hideTooltip(tooltip, popperInstance) {
    // Hide the tooltip
    tooltip.classList.remove('show');
    tooltip.classList.add('is-transitioning');
    activeTooltip = null;
    activePopper = null;
    setTimeout(() => {
      tooltip.classList.remove('is-transitioning');
    }, 510)

    // Disable the event listeners
    popperInstance.setOptions((options) => ({
      ...options,
      modifiers: [
        ...options.modifiers,
        { name: 'eventListeners', enabled: false },
      ],
    }));
  }

  function toggleTooltip(tooltip, popperInstance) {
    if (tooltip.classList.contains('show')) {
      hideTooltip(tooltip, popperInstance);
    } else {
      showTooltip(tooltip, popperInstance);
    }
  }

  disabledHotspots.forEach(hotspot => {

    const hotspotId = hotspot.getAttribute('id');
    const dot = hotspot.querySelector('circle.st1');
    const tooltip = document.querySelector(`[data-target=${hotspotId}]`);
    const tooltipId = tooltip.getAttribute('id');
    const tooltipPlacement = tooltip.getAttribute('data-placement');

    hotspot.setAttribute('aria-describedby', tooltipId);

    const popperInstance = createPopper(dot, tooltip, {
      placement: tooltipPlacement,
      modifiers: [offset,
        {
          name: 'offset',
          options: {
            offset: [0, 8],
          },
        },
        { name: 'eventListeners', enabled: false },
      ]
    });

    hotspot.addEventListener('click', () => {
      if (isTransitioning === false) {
        if (activePanel) {
          activePanel.hide();
        }
        if (activeTooltip && activeTooltip !== tooltip) {
          hideTooltip(activeTooltip, activePopper);
        }
        toggleTooltip(tooltip, popperInstance)
      }
    });
  })

  body.addEventListener('click', function () {
    if (activeTooltip) {
      hideTooltip(activeTooltip, activePopper);
    }
  })

  document.addEventListener('show.bs.offcanvas', function () {
    isTransitioning = true;
    body.classList.add('has-open-panel', 'has-panel-animating');
    if (activeTooltip) {
      hideTooltip(activeTooltip, activePopper);
    }
  })

  document.addEventListener('shown.bs.offcanvas', function () {
    body.classList.remove('has-panel-animating');
    isTransitioning = false;
  })

  document.addEventListener('hide.bs.offcanvas', function () {
    isTransitioning = true;
    activeHotspot.classList.remove('active');
    activeLogoBlock.classList.remove('active');
    activePanel = null;
    activeHotspot = null;
    body.classList.remove('has-open-panel');
  })

  document.addEventListener('hidden.bs.offcanvas', function () {
    isTransitioning = false;
  })
}

//
// Slideshow
//

const slideshowElem = document.querySelector('.site-slideshow');
const slides = [].slice.call(slideshowElem.querySelectorAll('.site-slideshow-slide'));

function slideshow(index = 0) {
  let slide = slides[index];
  let slideImg = document.getElementById(slide.getAttribute('data-slideshow-img'));
  slide.classList.add('show');

  if (slideImg) {
    slideImg.classList.add('show');
  }

  if (index < (slides.length - 1)) {
    slideshowTimer = setTimeout(() => {
      slide.classList.remove('show');
      if (slideImg) {
        slideImg.classList.remove('show');
      }
      slideshow(index + 1);
    }, "1500");
  } else {
    slideshowRunning = false;
    setTimeout(() => {
      body.classList.add('map-dots-shown');
    }, "300");
    return true;
  }
}

function skipSlideshow() {
  slideshowRunning = false;
  body.classList.add('map-dots-shown');
  if (slideshowTimer) {
    clearTimeout(slideshowTimer);
  }
  slides.forEach((slide, index, array) => {
    let slideImg = document.getElementById(slide.getAttribute('data-slideshow-img'));
    slide.classList.remove('show');
    if (slideImg) {
      slideImg.classList.remove('show');
    }
    slides[slides.length - 1].classList.add('show');
  })
}

//
// Load SVG map inline
//

// If it takes longer than 500ms to load the map, add "map-loading"
// class to show the loading spinner.
setTimeout(() => {
  if (!body.classList.contains('map-loaded')) {
    body.classList.add('map-loading');
  }
}, "500");

inlineSVG.init({
  svgSelector: '.site-map-svg',
  initClass: 'js-inlinesvg',
}, function () {
  // Slight delay to make sure svg is in the DOM before adding "map-loaded"
  // otherwise it won't transition the opacity.
  setTimeout(() => {
    body.classList.remove('map-loading');
    body.classList.add('map-loaded');
    document.querySelector('.site-map-spinner').remove();
    slideshowRunning = true;
    slideshow();
    initMap();
  }, "0");
});
